// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2074s","footer":"ReportModalFilter_footer__3o4h3"};